import { Fragment } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import { colors } from "@dotnet/telematics-design-system";

import { body1RegularStyles } from "shared";

import Logo from "../Logo";
import ColoredCircles from "./ColoredCircles";
import { ErrorElementsProps, TITLES } from "./types";

const ErrorElements = ({
    title,
    animation,
    animationCSS,
    message,
    errorButton
}: ErrorElementsProps) => {
    const { gray200, gray700, gray900 } = colors;

    const { t } = useTranslation();

    return (
        <Fragment>
            <header
                css={css({
                    padding: "16px 24px 15px 24px",
                    borderBottom: `1px solid ${gray200}`,
                    display: "flex",
                    alignItems: "center"
                })}
            >
                <Logo />
            </header>

            <main>
                <section className="remaining-height">
                    <div
                        className="remaining-height"
                        css={css({
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "100px 0"
                        })}
                    >
                        <div
                            css={css({
                                position: "relative",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "625px",
                                height: "416px",
                                boxSizing: "border-box",
                                border: `1px solid ${gray200}`,
                                borderRadius: "8px",

                                "@media (max-width: 839px)": {
                                    width: "410px",
                                    height: "273px"
                                },

                                "@media (max-width: 599px)": {
                                    width: "328px",
                                    height: "218px"
                                }
                            })}
                        >
                            <ColoredCircles />

                            <div>
                                {title === TITLES.Error && (
                                    <div
                                        css={css({
                                            color: "#162D3D",
                                            fontSize: "140px",
                                            fontWeight: "500",
                                            textTransform: "uppercase",

                                            "@media (max-width: 839px)": {
                                                fontSize: "92px"
                                            },

                                            "@media (max-width: 599px)": {
                                                fontSize: "74px"
                                            }
                                        })}
                                    >
                                        {t(`${title}##error`)}
                                    </div>
                                )}
                            </div>

                            <DotLottieReact
                                src={animation}
                                loop
                                autoplay
                                css={css(animationCSS)}
                            />
                        </div>

                        <div
                            css={css({
                                marginTop: "32px",
                                textAlign: "center",
                                padding: "0 16px",

                                h1: {
                                    color: gray900,
                                    fontSize: "32px",
                                    fontWeight: "500",
                                    lineHeight: "40px",
                                    letterSpacing: "0.25px",

                                    "@media(max-width: 599px)": {
                                        fontSize: "24px",
                                        lineHeight: "32px",
                                        letterSpacing: "unset"
                                    }
                                },

                                p: {
                                    ...body1RegularStyles,
                                    color: gray700
                                }
                            })}
                        >
                            <h1>{t(`${title}##title`)}</h1>

                            {message && <p>{message}</p>}

                            {errorButton}
                        </div>
                    </div>
                </section>
            </main>
        </Fragment>
    );
};

export default ErrorElements;
export { TITLES } from "./types";
